import React, { useState, useEffect, useContext, useRef } from 'react';
import ScrollAnimate from './ScrollAnimate';
import Purchase from './Stripe/Purchase';
/* global gtag */

const HeroSection = () => (
  <ScrollAnimate>
    <section className="hero">
      <h1>HackerNoon Blogging Course</h1>
      <div className="terminal-bar">
        &gt; People Who Blog Simply Win More 🏆
        <span className="blinking-cursor"></span>
      </div>
      <p>
        Blogging leads to faster promotions and consistent inbound opportunities. Join 45,000+ tech professionals who've discovered blogging is the tech career multiplier.
      </p>
      <div className="hero-stats">
        <div className="stat">
          <span className="stat-number">45K+</span>
          <span className="stat-label">Published Authors</span>
        </div>
        <div className="stat">
          <span className="stat-number">4M+</span>
          <span className="stat-label">Monthly Readers</span>
        </div>
      </div>
      <a className="cta-primary" href="#pricing">Buy Blogging Course</a>
      <a className="cta-secondary" href="#curriculum">&nbsp;Preview Curriculum&nbsp;</a>
    </section>
  </ScrollAnimate>
);

const ModuleCard = ({ module, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = (e) => {
    // Don't expand if clicking on a link or button
    if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON') return;
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={`module-card home ${module?.comingSoon ? 'module-card-soon' : ''} ${isExpanded ? 'expanded' : ''}`}
      data-index={index}
    // onClick={toggleExpanded}
    >
      <div className="module-header">
        <div className="module-icon" dangerouslySetInnerHTML={{ __html: module?.svgIcon }} />
        <div className="module-title">{module?.title}</div>
        <div className="module-desc">
          {module?.subTitle}
          <br />
          <br />
          <strong>Read more</strong>
        </div>
      </div>
      {module?.learningPoints && (
        <div className="module-body">
          <ul>
            {module?.learningPoints.map((learningPoint, idx) => (
              <React.Fragment key={idx}>
                <li>{learningPoint}</li>
                {idx < module?.learningPoints?.length - 1 && <br />}
              </React.Fragment>
            ))}
          </ul>
          <a className="module-btn" href="/my-courses">Start Module</a>
        </div>
      )}
    </div>
  );
};

// Modules Section
const ModulesSection = ({ templaterCourse = null }) => {


  return (
    <ScrollAnimate>
      <section className="modules-section" id="introduction">
        <div className="modules-title">Introducing the HackerNoon Blogging Course</div>

        <div className="all-modules-card">
          <div className="all-modules-content">
            <div className="all-modules-text">
              <h3>Write for the Internet in 2025 and Beyond 🚀</h3>
              <p>
                From the editorial team behind <strong>150,000+ published drafts</strong>, this self-paced course shows you
                how to write with clarity, get featured, build an engaged audience, and turn your writing into something
                bigger than a hobby.
              </p>

              {/* <video controls autoPlay muted width="100%" style={{marginTop: '16px', borderRadius: '12px'}}>
                <source src="https://youtu.be/Ir57-OhnykY?si=0aZ9EbbU2I7JWkxY" type="video/mp4" />
                Your browser does not support the video tag.
              </video> */}
              <iframe width="100%" height="700" src="https://www.youtube.com/embed/NfiZbYlSn9E?si=rAeQxGhW3sgQMnpR" frameBorder="0" allowFullScreen></iframe>
            </div>


          </div>
        </div>
        {(templaterCourse && templaterCourse?.modules?.length > 0) && (
          <>
            <h2 id="curriculum" className="modules-title">Blogging Course Modules</h2>
            <div className="modules-grid" style={{ marginTop: "32px" }}>
              {templaterCourse?.modules?.map((module, index) => (
                <ModuleCard key={index} module={module} index={index} />
              ))}
            </div>
          </>
        )}
      </section>
    </ScrollAnimate>
  );
};

const FacultyCard = ({ faculty }) => (
  <div className="faculty-card">
    <div className="faculty-header">
      <img src={faculty.image} alt={faculty.name} className="faculty-image" />
      <div className="faculty-info">
        <h3 className="faculty-name">{faculty.name}</h3>
        <p className="faculty-role">{faculty.role}</p>
      </div>
    </div>
    <p className="faculty-bio">{faculty.bio}</p>
    <a href={faculty.learnMoreLink} className="faculty-btn">Learn More</a>
    <a href={faculty.linkedinLink} className="faculty-btn">
      <svg id="linkedin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" style={{ verticalAlign: 'middle' }}>
        <path d="m22,2v-1H2v1h-1v20h1v1h20v-1h1V2h-1Zm-9,10v8h-3v-11h3v1h1v-1h4v1h1v10h-3v-8h-3Zm-9-4v-3h3v3h-3Zm3,1v11h-3v-11h3Z" />
      </svg>
    </a>
  </div>
);

const FacultySection = () => {
  const [shuffledFaculty, setShuffledFaculty] = useState([]);
  const [activeDot, setActiveDot] = useState(0);
  const carouselRef = useRef(null);

  const facultyData = [
    {
      name: "David Smooke",
      role: "Founder & CEO of HackerNoon",
      bio: "12+ years building one of the web's leading independent tech publishing platform HackerNoon (300M+ readers, 45k+ writers, $2.9M raised), with prior experience in content marketing, social media, and journalism. One of the first 5 hires of SmartRecruiters ($1.5B valuation as of 2023).",
      image: "images/david.jpeg",
      learnMoreLink: "https://hackernoon.com/u/David",
      linkedinLink: "https://www.linkedin.com/in/clarkkent/"
    },
    {
      name: "Linh Dao Smooke",
      role: "COO & Board of HackerNoon",
      bio: "14+ years scaling one of the web's leading tech media platform HackerNoon, following prior leadership roles in global education (Minerva University, UWC Vietnam), youth innovation (CKP Vietnam), and pedagogy research at Brown University.",
      image: "images/linh.jpeg",
      learnMoreLink: "https://linhdaosmooke.com/",
      linkedinLink: "https://www.linkedin.com/in/linhdaosmooke/"
    },
    {
      name: "Limarc Ambalina",
      role: "Director of Content at ISNation",
      bio: "10+ years' experience spanning editorial leadership, SEO strategy, and brand growth across tech media (HackerNoon, KDnuggets), corporations and startups (TaskUs, Gengo, ISNation), and pop culture journalism (JPbound, GaijinPot, Valnet).",
      image: "images/limarc.jpeg",
      learnMoreLink: "https://www.isnation.com/meet-the-team/limarc-ambalina",
      linkedinLink: "https://www.linkedin.com/in/limarc-ambalina-11604371/"
    },
    {
      name: "Sheharyar Khan",
      role: "Editor, Business & Economics",
      bio: "12+ years of journalism and communications experience, previously leading content, editorial teams, and corporate messaging at S&P Global across energy, healthcare, and mining sectors.",
      image: "images/sheharyar.jpeg",
      learnMoreLink: "https://hackernoon.com/u/sheharyarkhan",
      linkedinLink: "https://www.linkedin.com/in/sheharyar-k-51b308154/"
    },
    {
      name: "Asher Umerie",
      role: "Managing Editor at HackerNoon",
      bio: "5+ years of expertise in editorial strategy, brand communications, and digital marketing, shaping tech and startup storytelling through roles at Ripe Creatives and gomoney.",
      image: "images/asher.jpeg",
      learnMoreLink: "faculty-david.html",
      linkedinLink: "https://www.linkedin.com/in/asher-umerie/"
    },
    {
      name: "Mónica Freitas",
      role: "Senior Marketer at HackerNoon",
      bio: "8+ years of experience spanning marketing, communications, and operations, currently driving growth at HackerNoon while building on prior roles in digital marketing, content strategy, and tourism operations across Portugal and the UK.",
      image: "images/monica.jpeg",
      learnMoreLink: "https://hackernoon.com/u/monicafreitas",
      linkedinLink: "https://www.linkedin.com/in/m%C3%B3nica-freitas/"
    },
    {
      name: "Natasha Nel",
      role: "Content Marketing Specialist at Bitvavo",
      bio: "10+ years of experience in brand and content marketing, editorial leadership, and communications, spanning global roles at Bitvavo, Product Hunt, TNW, HackerNoon, and GetSmarter, with foundations in journalism at Cosmopolitan and The Cape Times.",
      image: "images/natasha.jpeg",
      learnMoreLink: "https://hackernoon.com/u/natasha",
      linkedinLink: "https://www.linkedin.com/in/natashanel/"
    },
    {
      name: "Kushal Tamrakar",
      role: "Editor & Support at HackerNoon",
      bio: "3+ years at HackerNoon in editorial, support, and operations roles, bringing expertise in content management, customer support, and organizational efficiency, building on early experience in technical support at the University of Colorado Boulder.",
      image: "images/kush.jpeg",
      learnMoreLink: "https://www.linkedin.com/in/kushal-tamrakar-337899224/",
      linkedinLink: "https://www.linkedin.com/in/kushal-tamrakar-337899224/"
    },
    {
      name: "Amy Tom",
      role: "Community Manager at D3",
      bio: "10+ years of experience in content marketing and community building, Amy has led brand campaigns, podcasts, partnerships, and editorial strategy across security automation, SaaS, and tech publishing for startups and global enterprises alike.",
      image: "images/amy.jpeg",
      learnMoreLink: "https://hackernoon.com/u/amymtom",
      linkedinLink: "https://www.linkedin.com/in/amymtom/"
    },
    {
      name: "Utsav Jaiswal",
      role: "Vice President of Sales at HackerNoon",
      bio: "6+ years at HackerNoon leading sales, partnerships, and business development, alongside prior roles in blockchain journalism, technical content, and business development, Utsav brings a unique blend of growth strategy, editorial expertise, and technical communication.",
      image: "images/utsav.jpeg",
      learnMoreLink: "https://hackernoon.com/u/Hackerhodl",
      linkedinLink: "https://www.linkedin.com/in/utsavjaiswal/"
    },
    {
      name: "Zaeem Shoaib Zuberi",
      role: "Publishing Editor at WSJ",
      bio: "15+ years of experience in journalism and editorial leadership, spanning roles at The Wall Street Journal, S&P Global, MT Newswires, CryptoSlate, and HackerNoon, Zaeem has built deep expertise in breaking news, financial and business reporting, team management, and data-driven editorial strategy.",
      image: "images/zaeem.jpeg",
      learnMoreLink: "https://hackernoon.com/u/zaeemshoaib",
      linkedinLink: "https://www.linkedin.com/in/zaeemshoaib/"
    },
    {
      name: "Adebola Adeniran",
      role: "Developer Relations Engineer at Tezos",
      bio: "10+ years spanning developer relations, fintech growth, and software engineering, Adebola has scaled teams from 5 to 70+, driven $5M+ in loan disbursements, built Web3/AI developer ecosystems at Tezos and Alloy, and delivered impactful technical advocacy, tools, and content that fueled multimillion-dollar pipelines.",
      image: "images/adebola.jpeg",
      learnMoreLink: "https://hackernoon.com/u/adebola",
      linkedinLink: "https://www.linkedin.com/in/adebola-niran/"
    },
    {
      name: "Celine A.",
      role: "Project Manager at Liora Co",
      bio: "7+ years spanning project management, education, research, and communications, Celine has led international ed-tech and community programs, optimized systems and stakeholder coordination, and built scalable frameworks that improved efficiency, engagement, and impact across diverse industries.",
      image: "images/celine.jpeg",
      learnMoreLink: "https://hackernoon.com/u/onyawoibi",
      linkedinLink: "https://www.linkedin.com/in/celineaju/"
    },
    {
      name: "James Bore",
      role: "Cybersecurity Expert",
      bio: "15+ years of cybersecurity leadership, consultancy, and publishing, James has driven regulatory security at Ofgem, led Bores Group as Managing Director, advised global firms, taught future cyber talent, and authored influential works shaping security awareness and practice worldwide.",
      image: "images/james.jpeg",
      learnMoreLink: "https://hackernoon.com/u/jamesbore",
      linkedinLink: "https://www.linkedin.com/in/jbore/"
    },
    {
      name: "Elhadj Chikhaoui",
      role: "AI Expert",
      bio: "5+ years in product development, consulting, and digital strategy, Elhadj combines technical insight with practical execution. He has built digital products, led data and AI initiatives, and managed cross-functional work across startups and enterprises—turning complex ideas into clear, actionable plans that help teams innovate and scale.",
      image: "images/elhadj.jpeg",
      learnMoreLink: "faculty-david.html",
      linkedinLink: "https://www.linkedin.com/in/elhadj-chikhaoui/"
    },
    {
      name: "Saaniya Chugh",
      role: "Senior Technical Consultant at ServiceNow",
      bio: "9+ years of IT service management expertise, Saaniya has led ServiceNow consulting and development across global firms like ServiceNow, BDO, LinkedIn, Deloitte, and TCS, delivering enterprise solutions that streamline operations and drive business value.",
      image: "images/saaniya.jpeg",
      learnMoreLink: "https://hackernoon.com/u/saaniyachugh",
      linkedinLink: "https://www.linkedin.com/in/saaniya-chugh/"
    }
  ];

  useEffect(() => {
    // Fisher-Yates shuffle
    const shuffled = [...facultyData];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    setShuffledFaculty(shuffled);
  }, []);

  const scrollToCard = (index) => {
    if (carouselRef.current) {
      const cardWidth = 320 + 32; // Adjust based on your CSS
      carouselRef.current.scrollTo({
        left: index * cardWidth,
        behavior: 'smooth'
      });
    }
  };

  const handleScroll = () => {
    if (carouselRef.current) {
      const cardWidth = 320 + 32;
      const index = Math.round(carouselRef.current.scrollLeft / cardWidth);
      setActiveDot(index);
    }
  };

  return (
    <ScrollAnimate>
      <section className="faculty-section" id="faculty">
        <h2 className="modules-title">Meet the Faculty</h2>
        <div className="faculty-carousel" id="facultyCarousel" ref={carouselRef} onScroll={handleScroll}>
          {shuffledFaculty.map((faculty, index) => (
            <FacultyCard key={index} faculty={faculty} />
          ))}
        </div>
        <div className="carousel-dots">
          {shuffledFaculty.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === activeDot ? 'active' : ''}`}
              onClick={() => scrollToCard(index)}
            />
          ))}
        </div>
      </section>
    </ScrollAnimate>
  );
};

const CourseFeaturesSection = () => (
  <ScrollAnimate>
    <section className="course-features" id="features">
      <div className="container">
        <h2 className="section-title">What You Get Inside The Blogging Fellowship Course</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">⏰</div>
            <h3>Self-Paced Learning</h3>
            <p>Learn at your own speed with lifetime access to all course materials. Start today, finish when you're ready.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🧪</div>
            <h3>Proven Exercises</h3>
            <p>The same writing exercises and strategies that grew HackerNoon into a 4M+ reader platform. Battle-tested and refined.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎬</div>
            <h3>8+ Hours of Original Video Tutorials</h3>
            <p>High-quality video content walking you through every lesson on blogging in tech, from our team of experts.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💥</div>
            <h3>Online Community Access</h3>
            <p>Join thousands of tech bloggers sharing wins, getting feedback, and supporting each other's growth.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📚</div>
            <h3>Amazing Curriculum</h3>
            <p>8 comprehensive modules covering everything from writing fundamentals to AI optimization and scaling your influence in tech.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Real-World Application</h3>
            <p>Every lesson includes practical assignments that build your actual blog and online presence as you learn.</p>
          </div>
        </div>

        <div className="certificate-card">
          <div className="certificate-content">
            <div className="certificate-icon">🎓</div>
            <div className="certificate-text">
              <h3>HackerNoon Blogging Fellowship Graduate Certificate</h3>
              <p>Upon completion, receive an official certificate recognizing your expertise in technical writing and content strategy. Many HackerNoon Fellows have even leveraged their published articles for career milestones — from job offers to successful visa applications. Showcase your achievement on LinkedIn, in your portfolio, and with future employers.</p>
            </div>
          </div>
          <div className="certificate-image-wrapper">
            <img src="images/certificate.png" alt="Graduate Certificate" />
          </div>
        </div>
      </div>
    </section>
  </ScrollAnimate>
);

const ValuePropositionSection = () => (
  <ScrollAnimate>
    <section className="value-prop" id="values">
      <div className="value-container">
        <h2 className="section-title">Why Consistent Blogging Changes Everything</h2>
        <div className="value-grid">
          <div className="value-card">
            <div className="value-icon">🎯</div>
            <h3>Build Unshakeable Authority</h3>
            <p>Quality articles demonstrate your expertise better than any resume. Colleagues, managers, and industry leaders will recognize your deep thinking and technical insight.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">🚪</div>
            <h3>Create Serendipitous Opportunities</h3>
            <p>Your published work becomes a magnet for unexpected opportunities - speaking gigs, consulting offers, job opportunities, and collaborations you never saw coming.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">🌐</div>
            <h3>Expand Your Professional Network</h3>
            <p>Connect with 4M+ monthly readers including hiring managers, startup founders, and tech leaders who actively engage with quality technical content.</p>
          </div>
          <div className="value-card">
            <div className="value-icon">💼</div>
            <h3>You're a Business, Man</h3>
            <p>A startup would never not have a blog. Your career is a startup business, blog it seriously.</p>
          </div>
        </div>
      </div>
    </section>
  </ScrollAnimate>
);

const TestimonialCard = ({ testimonial }) => (
  <div className="testimonial-card">
    <div className="testimonial-quote">{testimonial.quote}</div>
    <div className="testimonial-person">
      <img src={testimonial.avatar} alt={testimonial.name} className="testimonial-avatar" />
      <div>
        <div className="testimonial-name">{testimonial.name}</div>
        <div className="testimonial-role">{testimonial.role}</div>
      </div>
    </div>
  </div>
);

const TestimonialsSection = () => {
  const [shuffledTestimonials, setShuffledTestimonials] = useState([]);

  const testimonials = [
    {
      quote: `"As a result of the (HackerNoon) fellowship I've also had a few commission requests and found that fitting a bit of writing into my day is a great way to change pace from my usual work.\n\nVery happy to have added this new string to my bow, and give me a shout if you want any writing done."`,
      name: "James Bore",
      role: "Cybersecurity Expert",
      avatar: "testimonials/james.png"
    },
    {
      quote: `"I was very happy to be given creative free reign on my stories and also given less editorial oversight due to my editorial qualities, which was also incredibly uplifting and encouraging to have for a gaming-intensive fellowship."`,
      name: "Jeffrey Harris",
      role: "Journalist, Video Writer & Creator",
      avatar: "/testimonials/jeffrey.png"
    },
    {
      quote: `"My greatest challenge was in adjusting my writing to fit the new requirements that came from writing for websites. There's a lot of things to consider that I struggled to fully account for when I researched sometimes. Fortunately, Limarc Ambalina gave me plenty of help with learning how to get better at all of that.\n\nI've had many gratifying moments during the Fellowship. Getting to write endlessly about modding and seeing many of those articles succeed was quite a lot of fun."`,
      name: "Nicolas Ng",
      role: "Journalist at Channel News Asia (CNA)",
      avatar: "testimonials/nicolas.jpeg"
    },
    {
      quote: `"It was a truly worthwhile experience that was disguised as hard work! It gave me confidence in my digital writing skills and helped me learn a bit more about keyword research and SEO.\n\nThank you for all the wonderful people and mentors at HackerNoon."`,
      name: "Amy Shah",
      role: "Psychiatrist at Norton Healthcare",
      avatar: "testimonials/amy.png"
    },
    {
      quote: `"Seeing my writing skill grow over time was another gratifying moment. Limarc Ambalina, you couldn't have been a better manager/supervisor—great encouragement and constructive criticism that has shaped me as a writer.\n\nWriting for Hacker Noon has been a pleasure, due to the positive vibes and energy of the fellowship and leadership."`,
      name: "Jack Boreham",
      role: "Lead Writer & Editor at Resonance",
      avatar: "testimonials/jack.jpeg"
    },
    {
      quote: `"A struggle for me was reeling in that AP, professional, writing style, and learning how to relax. At the same time, I still wanted to have good, cohesive grammar.\n\nGratifying moments happened when my articles would do well. It's a toss-up how well one of your articles will do, you can have fantastic keywords and still get below average views. So, when one of my articles had great views, it felt good."`,
      name: "Jose Hernandez",
      role: "Entertainment Writer",
      avatar: "testimonials/jose.jpeg"
    }
  ];

  useEffect(() => {
    // Fisher-Yates shuffle
    const shuffled = [...testimonials];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    setShuffledTestimonials(shuffled);
  }, []);

  return (
    <ScrollAnimate>
      <section className="testimonial-section" id="testimonials">
        <h2 className="testimonial-title">What Our Students Say</h2>
        <div className="testimonial-grid">
          {shuffledTestimonials.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
      </section>
    </ScrollAnimate>
  );
};

const ContentOwnershipSection = () => {
  // useEffect(() => {
  //   // Check if script is already loaded
  //   const existingScript = document.querySelector('script[src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"]');

  //   if (!existingScript) {
  //     // Load Lottie Player script
  //     const script = document.createElement('script');
  //     script.src = 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js';
  //     script.async = true;
  //     script.setAttribute('data-loaded-by', 'content-ownership');
  //     document.head.appendChild(script);

  //     return () => {
  //       // Only remove if we added it and it's still there
  //       const scriptToRemove = document.querySelector('script[src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"][data-loaded-by="content-ownership"]');
  //       if (scriptToRemove) {
  //         document.head.removeChild(scriptToRemove);
  //       }
  //     };
  //   }

  //   // No cleanup needed if we didn't add the script
  //   return () => {};
  // }, []);

  return (
    <ScrollAnimate>
      <section className="content-ownership" id="ownership">
        <div className="container">
          <div className="ownership-content">
            <div className="ownership-text">
              <h2 className="section-title">Choose Your Niche, Own Your Content</h2>
              <p>Most educational programs claim ownership of student work - universities own research, colleges own projects, and online publications own articles. This isn't that.</p>
              <p><strong>At HackerNoon, contributors own their content.</strong> You build a portfolio during the fellowship that belongs entirely to you. Republish it on your personal website, share it with potential employers, or use it however your heart pleases.</p>
              <p>While you're learning to write and growing your career, you're also building valuable intellectual property that stays with you forever.</p>
            </div>
            <div className="ownership-image">
              <lottie-player
                src="/ownership_lottie.json"
                background="transparent"
                speed="1"
                style={{ width: '300px', height: '300px' }}
                loop
                autoplay>
              </lottie-player>
            </div>
          </div>
        </div>
      </section>
    </ScrollAnimate>
  );
};

const PricingSection = ({ courseService = null, handleSetCheckoutData, rand = 29, title = "Choose Your Path to Success" }) => {

  return (
    <ScrollAnimate>
      <section className="pricing" id="pricing">
        <div className="container">
          <h2 className="section-title">{title}</h2>
          <div className="pricing-grid">
            <div className="pricing-card featured">
              <div className="popular-badge">{rand} humans on the internet are eyeing this</div>
              <h3>{courseService?.priceOptions[0]?.title}</h3>
              <div className="price">${courseService?.priceOptions[0]?.price}</div>
              <p className="price-period">{courseService?.priceOptions[0]?.subTitle}</p>
              <ul className="features">
                {courseService?.benefits?.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
              <button
                className="cta-primary"
                id="buy-btn"
                onClick={() => {
                  gtag('event', 'buy_blog_course_click', {
                    event_category: 'ecommerce',
                    event_label: 'blogging_course'
                  });
                  handleSetCheckoutData();
                }}
              >
                Buy Blogging Course
              </button>
            </div>
          </div>
        </div>
      </section>
    </ScrollAnimate>
  )
};

const FAQItem = ({ question, answer }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="faq-item">
      <div className="faq-question" onClick={() => setIsActive(!isActive)}>
        <span>{question}</span>
        <span className={`faq-toggle ${isActive ? 'active' : ''}`}>+</span>
      </div>
      <div className={`faq-answer ${isActive ? 'active' : ''}`}>
        <div className="faq-answer-content" dangerouslySetInnerHTML={{ __html: answer }} />
      </div>
    </div>
  );
};


const FAQSection = () => {
  const faqs = [
    {
      question: "What's the flow for buying and accessing the blogging course?",
      answer: `If you don't have a HackerNoon account, no worries. After the purchase, we'll automatically create your account, log you in, add the course to your profile, and take you to the receipt page.      
      <br><br>
      If you have a HackerNoon account, please log in first, then you can buy the course. Once purchased, we will add the course to your account and take you straight to the receipt page.`
    },
    {
      question: "Do I need to be an experienced writer to join?",
      answer: `Not at all. This course is built for people in tech who want to start writing, even if they've never published before. Many fellows have gone from zero to published authors in just weeks using the same exercises that grew HackerNoon's 4M+ reader base.
      <br><br>
      At the same time, it's also valuable for seasoned professionals - like cybersecurity experts, software engineers, and even PhDs - who already write but want to boost their blog quality, consistency, and impact.`
    },
    {
      question: "How long does it take to complete the course?",
      answer: "Most students complete the 8 modules in 6-8 weeks, but since it's self-paced, you can go faster or slower. You have lifetime access, so there's no rush. Many students start seeing career benefits after publishing just their first few articles."
    },
    {
      question: "What if I don't have time to blog regularly?",
      answer: "The course teaches you how to blog efficiently. Many successful students publish just once or twice a month. It's about consistency and quality, not quantity. Even publishing quarterly can significantly impact your career trajectory."
    },
    {
      question: "Will I really get published on HackerNoon?",
      answer: "Yes! Course graduates have published over 850 articles on HackerNoon. Our editorial team helps ensure your work meets publication standards. Plus, you'll learn the insider secrets that get articles featured and promoted to our 4M+ monthly readers."
    },
    {
      question: "How is this different from other writing courses?",
      answer: "Most writing courses are generic. This is specifically for people in tech, taught by the team that built one of the world's largest tech publications. You're not just learning to write - you're learning to build your career through strategic content creation."
    },
    {
      question: "What if I'm not technical enough?",
      answer: "If you work in tech - whether you're a developer, designer, product manager, or in sales/marketing at a tech company - you have valuable insights to share. The course shows you how to identify and communicate your unique perspective, regardless of your technical depth."
    },
    {
      question: "I cannot afford the course. Do you offer financial aid?",
      answer: `Yes! Students with verified status qualify for a 50% discount. To get verified, you'll need to fill out <a href="https://financial-aid-student-hackernoon-blogging-course.paperform.co/" target="_blank" rel="noopener noreferrer">this form</a> and provide proof such as a school-issued email address, valid student ID card, enrollment/acceptance letter, transcript, tuition receipt, ISIC card, or other official documentation.
      You'll pay $149 upfront (50% off), and once we confirm your status, you'll receive an access code to unlock the course.
      <br><br>
      Not a student? You can still apply for financial aid. Please go through <a href="https://financial-aid-non-student-hackernoon-blogging-course.paperform.co/" target="_blank" rel="noopener noreferrer">this form</a> to submit as a non-student, and you'll need to be more thorough in your responses — explain why you deserve support, how the course will help your career or personal growth, and why the discounted rate is necessary for you to participate.
      <br><br>
      As part of the discount program, you'll also be asked to submit a HackerNoon story using our <a href="https://app.hackernoon.com/blogging-templates" target="_blank" rel="noopener noreferrer">blogging templates</a>. This helps ensure active engagement in the community while accessing the discounted rate.
      `
    },
    {
      question: "What's the refund policy?",
      answer: `You can request a full refund within 7 days of purchase if you decide the program isn't for you. To be eligible, please submit your refund request within this period via this form.
      <br><br>
      Please note that participants who receive a refund will not be eligible for a course certificate and will lose access to the private community. Refunds are not available after the 7-day period has passed.`
    },
    {
      question: "Can blogging regularly really boost my career and help me become an expert in my field?",
      answer: "Yes. Writing consistently builds your internet reputation, increases your visibility, and creates compound career momentum. Many of our students earn promotions, speaking invites, consulting work, and become the go-to voices in their niches simply by publishing their ideas. Your expertise becomes known — and that becomes your advantage."
    }
  ];

  return (
    <ScrollAnimate>
      <section className="faq" id="faq">
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="faq-items">
            {faqs.map((faq, index) => (
              <FAQItem key={index} question={faq.question} answer={faq.answer} />
            ))}
          </div>
        </div>
      </section>
    </ScrollAnimate>
  );
};


const FooterCTASection = () => (
  <ScrollAnimate>
    <section className="footer-cta">
      <div className="container">
        <h2 className="section-title">Scale Your Digital Authority Today</h2>
        <p className="hero-subtitle">Your technical expertise deserves a platform. Join hundreds of developers who've discovered that consistent, quality blogging compounds into career opportunities they never imagined.</p>
        <a href="#pricing" className="cta-primary">Buy Blogging Course</a>
      </div>
    </section>
  </ScrollAnimate>
);


export {
  HeroSection,
  ModulesSection,
  FacultyCard,
  FacultySection,
  CourseFeaturesSection,
  ValuePropositionSection,
  TestimonialsSection,
  ContentOwnershipSection,
  PricingSection,
  FAQSection,
  FooterCTASection
};
